import { render, staticRenderFns } from "./HomepageIntroductionBox.vue?vue&type=template&id=4cf7e17a&scoped=true&"
import script from "./HomepageIntroductionBox.vue?vue&type=script&lang=ts&"
export * from "./HomepageIntroductionBox.vue?vue&type=script&lang=ts&"
import style0 from "./HomepageIntroductionBox.vue?vue&type=style&index=0&id=4cf7e17a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4cf7e17a",
  null
  
)

export default component.exports